import {useEffect} from "react";
import {toast} from "react-toastify";
import {useUserActions} from "./store/useActions";
import {coreGetUser, coreGetMaxUser} from "./api/core";
import {useUserSelector} from "./store/useSelectors";
import HapticFeedback from "./components/HapticFeedback";
import CreateOrder from "./components/CreateOrder";
import DriverLocationPicker from "./components/DriverLocationPicker";
import ErrorBoundary from "./components/ErrorBoundary";
import ActiveOrderMenu from "./components/ActiveOrderMenu";
import Loader from "./components/Loader";
import {createLogger} from "./utils/logger";

const log = createLogger("auth");


const App = (props) => {

    const {
        token: userAuthToken,
        data: userData,
        loaded: userLoaded,
    } = useUserSelector()
    const {setUserData} = useUserActions()

    useEffect(() => {
        // Определяем платформу
        const params = new URLSearchParams(window.location.search);
        const tgToken = params.get("telegram_auth_token");

        // MAX WebApp: initDataUnsafe доступен через window.WebApp
        const maxWebApp = window.WebApp;
        const maxUser = maxWebApp && maxWebApp.initDataUnsafe && maxWebApp.initDataUnsafe.user;

        log.info("Платформа определена", {
            hasTgToken: !!tgToken,
            hasMaxUser: !!maxUser,
            maxWebApp: !!maxWebApp,
            telegramWebApp: !!window.Telegram?.WebApp,
        });

        if (tgToken) {
            // Telegram: есть token в URL
            log.info("Вход через Telegram", {token: tgToken});
            coreGetUser(tgToken).then(
                response => {
                    log.info("Пользователь Telegram загружен", {id: response.data?.id});
                    setUserData(response.data);
                }
            ).catch(
                error => {
                    log.error("Пользователь Telegram не найден", {
                        code: error?.response?.status,
                        message: error?.message,
                    });
                    toast.error("Пользователь не найден");
                }
            );
        } else if (maxUser && maxUser.id) {
            // MAX: аутентификация по user.id из initDataUnsafe
            log.info("Вход через MAX", {maxUserId: maxUser.id});
            coreGetMaxUser(maxUser.id).then(
                response => {
                    log.info("Пользователь MAX загружен", {id: response.data?.id});
                    setUserData(response.data);
                }
            ).catch(
                error => {
                    log.error("Пользователь MAX не найден", {
                        code: error?.response?.status,
                        message: error?.message,
                    });
                    toast.error("Пользователь не найден в MAX");
                }
            );
        } else {
            log.error("Не удалось определить способ входа: нет ни Telegram-токена, ни пользователя MAX");
            toast.error("Не удалось определить пользователя");
        }
        try {
            // Универсальная инициализация (Telegram + MAX)
            const { expand, ready, enableClosingConfirmation, onViewportChanged } = require('./services/platform');
            expand();
            ready();
            enableClosingConfirmation();
            onViewportChanged(() => {
                expand();
                setTimeout(() => {
                    const maps = document.querySelectorAll('.leaflet-container');
                    maps.forEach(el => {
                        if (el._leaflet_map) el._leaflet_map.invalidateSize();
                    });
                }, 300);
            });
        } catch (e) {
            log.warn("Инициализация WebApp SDK не удалась", e);
        }
    }, []);

    if (!userLoaded) {
        return <Loader text={"Загрузка..."} />;
    }

    const params = new URLSearchParams(window.location.search);
    const isManagerMode = params.get("manager") === "1" || params.get("WebAppStartParam") === "manager";
    const isDriverLocationPicker = params.get("pick_location") === "driver" || params.get("WebAppStartParam") === "pick_location";
    const showCreateOrder = isManagerMode || userData?.is_manager || !userData?.has_active_order;

    return (
        <>
            <HapticFeedback/>
            { isDriverLocationPicker ? <DriverLocationPicker /> : showCreateOrder ? <CreateOrder /> : <ErrorBoundary><ActiveOrderMenu /></ErrorBoundary>}
        </>
    );
};

export default App;
